import React from 'react'

import List from '../../components/List'

import { ROUTE_NAME, API_URL } from '../constants'

const USER_SORT_FUNC = (a, b) => {
  if (!a && !b) return 0
  if (!a) return -1
  if (!b) return 1

  //return a.username === b.username ? 0 : a.username < b.username ? -1 : 1
  return a.lastName === b.lastName
    ? a.firstName === b.firstName
      ? a.username < b.username
        ? -1
        : 1
      : a.firstName < b.firstName
      ? -1
      : 1
    : a.lastName < b.lastName
    ? -1
    : 1
}

const UserList = () => {
  const columns = [
    { header: 'Id', value: (item) => item.id },
    {
      header: 'Name',
      value: (item) => `${item.lastName}, ${item.firstName}`,
      isLink: true,
    },
    { header: 'Username', value: (item) => item.username },
    { header: 'Roles', value: (item) => item.roles.length },
  ]
  return (
    <List
      title="Users"
      routeName={ROUTE_NAME}
      apiUrl={API_URL}
      columns={columns}
      sortFunc={USER_SORT_FUNC}
    />
  )
}

export default UserList
